
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/access",
      function () {
        return require("private-next-pages/order/access/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/access"])
      });
    }
  